exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn.dropdown-toggle .caret {\r\n    margin-left: 4px;\n}\n.dropdown-menu > li > a {\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
